import { tz as tzFn } from '@date-fns/tz';
import type { TimeZone } from '@iheartjane/types';
import { timezone } from '@iheartjane/utils';
import { add, isBefore, parse } from 'date-fns';

export function openingAndClosing(
  { from, to }: { from: string; to: string },
  tz: TimeZone,
  now: Date = new Date()
): [Date, Date] {
  const timeZone = timezone(tz);
  const opening = parse(from, `HH:mm`, now, { in: tzFn(timeZone) });
  let closing = parse(to, `HH:mm`, now, { in: tzFn(timeZone) });

  // A closing time at or before the opening time falls on the following day,
  // ex. 8am-2am, or 8am-8am for 24 hours.
  if (!isBefore(opening, closing)) {
    closing = add(closing, { days: 1 });
  }

  return [opening, closing];
}
